/*
 * @Description:
 * @Date: 2024-12-13 17:06:19
 */
import {
  useInputColumn,
  useSelectColumn,
  useDatePickerColumn
} from 'xrk-components';
import {
  ORDER_PRICE_TYPE,
  PAY_TYPE,
  ORDER_PAY_STATUS,
  TERMINAL_TYPE
} from '../constants/index';
import { PAY_PASSAGEWAY_MAPPING } from '@/common/constants/bank/index';
import { taxPatternMapping } from '@constants/project';

/** 手机号 */
export const phoneSearch = useInputColumn({
  label: '手机号',
  prop: 'phone',
  type: 'input',
  config: {
    type: 'tel',
    placeholder: '请输入手机号'
  }
});

/** 订单编号 */
export const orderNoSearch = useInputColumn({
  prop: 'orderNo',
  type: 'input',
  label: '订单编号',
  config: {
    placeholder: '请输入'
  }
});

/** 关联项目服务费订单编号 */
export const refOrderNoSearch = useInputColumn({
  prop: 'refOrderNo',
  type: 'input',
  label: '关联项目服务费订单编号',
  config: {
    placeholder: '请输入'
  }
});

/** 关联客户结算单号 */
export const refSettlementNoSearch = useInputColumn({
  prop: 'refSettlementNo',
  type: 'input',
  label: '关联客户结算单号',
  config: {
    placeholder: '请输入'
  }
});

/** 客户名称 */
export const customerNameSearch = useInputColumn({
  prop: 'customerName',
  type: 'input',
  label: '客户名称',
  config: {
    placeholder: '请输入'
  }
});

/** 个体工商户名称 */
export const individualNameSearch = useInputColumn({
  prop: 'individualName',
  type: 'input',
  label: '个体工商户名称',
  config: {
    placeholder: '请输入'
  }
});

/** 终端服务人员 */
export const fullNameSearch = useInputColumn({
  prop: 'userName',
  type: 'input',
  label: '终端服务人员',
  config: {
    placeholder: '请输入'
  }
});

/** 结算单号 */
export const industryFenpeiCodeSearch = useInputColumn({
  prop: 'industryFenpeiCode',
  type: 'input',
  label: '结算单号',
  config: {
    placeholder: '请输入'
  }
});

/** 项目名称 */
export const projectNameSearch = useInputColumn({
  prop: 'projectName',
  type: 'input',
  label: '项目名称',
  config: {
    placeholder: '请输入'
  }
});

/** 项目编码 */
export const projectNoSearch = useInputColumn({
  prop: 'projectCode',
  type: 'input',
  label: '项目编码',
  config: {
    placeholder: '请输入'
  }
});

/** 交易结构 */
export const taxCollectionPatternSearch = useSelectColumn({
  prop: 'taxPattern',
  label: '交易结构',
  config: {
    placeholder: '请选择',
    options: taxPatternMapping
  }
});

/** 终端类型 */
export const terminalTypeSearch = useSelectColumn({
  prop: 'terminalType',
  label: '终端类型',
  config: {
    placeholder: '请选择',
    options: TERMINAL_TYPE
  }
});

/** 工业名称 */
export const entpNameSearch = useInputColumn({
  prop: 'industryName',
  type: 'input',
  label: '工业名称',
  config: {
    placeholder: '请输入'
  }
});

/** 供应商名称 */
export const supplierNameSearch = useInputColumn({
  prop: 'supplierName',
  type: 'input',
  label: '供应商名称',
  config: {
    placeholder: '请输入'
  }
});

/** 订单类型 */
export const orderTypeSearch = useSelectColumn({
  prop: 'orderType',
  label: '订单类型',
  config: {
    placeholder: '请选择',
    options: ORDER_PRICE_TYPE
  }
});

/** 订单生成时间 */
export const orderTimeAtSearch = useDatePickerColumn({
  prop: 'orderTime',
  label: '订单生成时间',
  style: {
    width: '270px'
  },
  config: {
    type: 'daterange'
  }
});

/** 订单支付时间 */
export const orderPayTimeAtSearch = useDatePickerColumn({
  prop: 'orderPayTime',
  label: '订单支付时间',
  style: {
    width: '270px'
  },
  config: {
    type: 'daterange'
  }
});

/** 订单完结时间 */
export const orderFinishTimeSearch = useDatePickerColumn({
  prop: 'orderFinishTime',
  label: '订单完结时间',
  style: {
    width: '270px'
  },
  config: {
    type: 'daterange'
  }
});

/** 供应商支付方式 */
export const supplierPayTypeSearch = useSelectColumn({
  prop: 'supplierPayType',
  label: '供应商支付方式',
  config: {
    placeholder: '请选择',
    options: PAY_TYPE
  }
});

/** 客户支付方式 */
export const csoPayTypeSearch = useSelectColumn({
  prop: 'payType',
  label: '客户支付方式',
  config: {
    placeholder: '请选择',
    options: PAY_TYPE
  }
});

/** 支付通道 */
export const payPassagewayNameSearch = useSelectColumn({
  prop: 'payPassagewayCode',
  label: '支付通道',
  config: {
    placeholder: '请选择',
    options: PAY_PASSAGEWAY_MAPPING
  }
});

/** 支付状态 */
export const payStatusSearch = useSelectColumn({
  prop: 'payStatus',
  label: '支付状态',
  config: {
    placeholder: '请选择',
    options: ORDER_PAY_STATUS
  }
});

/** 供应商支付状态 */
export const supplierPayStatusSearch = useSelectColumn({
  prop: 'supplierPayStatus',
  label: '供应商支付状态',
  config: {
    placeholder: '请选择',
    options: ORDER_PAY_STATUS
  }
});
